import {
	Box,
	Grid,
	Typography,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	TextField,
	InputAdornment,
	Checkbox,
	Button,
	FormControlLabel,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import React, { useState } from "react";
import { colors, sizes } from "../../setupUtils";
import { useDispatch, useSelector } from "react-redux";
import TransferList from "./CreateTransferList";
import BasicModal from "./CreateBasicModal";
import {
	getCustomers,
	getRelshipLevel,
	setCGState,
} from "../customerGroupSetupSlice";
import { useEffect } from "react";
import { lightBlue } from "@mui/material/colors";
import CollapseSection from "../../../../components/ui/CollapseSection";

export default function CreateSelectCustomer() {
	const [value, setValue] = useState();
	const cgState = useSelector((store) => store.customerGroupSetup);
	const dispatch = useDispatch();
	const {
		country,
		countryID,
		customerType,
		customerTypeCode,
		customerLevels,
		customerLevel,
		customerLevelID,
		relShipLevels,
		relShipLevel,
		relShipLevelID,
		customerName,
		activeCustomer,
		newCustomer,
		customers,
		selCustomers,
	} = cgState;

	useEffect(() => {
		if (relShipLevels.length <= 0) {
			dispatch(getRelshipLevel());
		}
	}, []);

	function showMessage(message, severity) {
		dispatch(setCGState("createMessage", message));
		dispatch(setCGState("createMessageSeverity", severity));
		dispatch(setCGState("createMessageOpen", true));
	}

	function updateCustomerLevel(event) {
		if (country.length <= 0) {
			showMessage("Please select a country", "info");
			return;
		}
		if (customerType.length <= 0) {
			showMessage("Please select customer type", "info");
			return;
		}

		const level = event.target.value;
		const levelId = customerLevels.find(
			(item) => item.customerLevel === level
		).customerLevelID;
		dispatch(setCGState("customerLevel", level));
		dispatch(setCGState("customerLevelID", levelId));
		dispatch(setCGState("customers", []));
		dispatch(setCGState("selCustomers", []));
	}

	function updateRelshipLevel(event) {
		const relship = event.target.value;
		let id = "";
		if (relship === "All") {
			id = 0;
		} else {
			id = relShipLevels.find(
				(item) => item.trustDesc === relship
			).trustLevelID;
		}
		dispatch(setCGState("relShipLevel", relship));
		dispatch(setCGState("relShipLevelID", id));
	}

	function updateCustomerName(event) {
		const name = event.target.value;
		dispatch(setCGState("customerName", name));
	}

	function setChecked(event, stateName) {
		const check = event.target.checked;
		dispatch(setCGState(stateName, check));
	}

	function searchCustomer() {
		dispatch(setCGState("is_customer_refresh", true));
		if (country.length <= 0) {
			showMessage("Please select a country", "info");
			return;
		}
		if (customerType.length <= 0) {
			showMessage("Please select customer type", "info");
			return;
		}
		if (customerLevel.length <= 0) {
			showMessage("Please select customer level", "info");
			return;
		}

		dispatch(
			getCustomers({
				countryID,
				customerTypeCode,
				customerLevelID,
				customerName,
				activeCustomer,
				relShipLevelID,
				newCustomer,
			})
		);
	}

	return (
		<Box>
		{/* <Typography sx={{ fontWeight: "bold", color: "blue.main", width: "100%", }} 
				className="compHeading"
				>
					Select Customers
				</Typography> */}
		<CollapseSection title="Select Customers">
		<Box sx={{ mt: 3, border: 1, borderRadius: 1, p: 2, borderColor: "#c6c6c6" }}>

			<Box sx={{ mt: 1,}}>
				<Grid container columns={7} spacing={3} alignContent={"flex-end"}>
					<Grid item sm={2}>
						<FormControl>
							<InputLabel>Level</InputLabel>
							<Select
								value={customerLevel}
								label="Level"
								sx={{
									height: sizes.h35,
									width: sizes.w300,
									color: colors.black,
									mt: 1,
								}}
								onChange={updateCustomerLevel}
							>
								{customerLevels.map((level, index) => {
									return (
										<MenuItem key={index} value={level.customerLevel}>
											{level.customerLevel}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Grid>

					<Grid item sm={2}>
						<FormControl>
							<InputLabel>Relationship Level</InputLabel>
							<Select
								value={relShipLevel}
								label="Relationship Level"
								sx={{
									height: sizes.h35,
									width: sizes.w300,
									color: colors.black,
									mt: 1,
								}}
								onChange={updateRelshipLevel}
							>
								<MenuItem value={"All"}>All</MenuItem>
								{relShipLevels.map((item, index) => {
									return (
										<MenuItem key={index} value={item.trustDesc}>
											{item.trustDesc}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Grid>

					<Grid item sm={3}>
						<TextField
							label="Customer Name"
							InputProps={{
								startAdornment: (
									<InputAdornment position="end">
										<EditIcon />
									</InputAdornment>
								),
							}}
							variant="standard"
							value={customerName}
							onChange={updateCustomerName}
						/>
					</Grid>
					<Grid item sm={2} md={1.5} sx={{ml: "calc(auto - 20px)",}}>
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
							}}
						>
							<FormControlLabel
								control={
									<Checkbox
										checked={activeCustomer}
										onChange={(event) => {
											console.log(event.target.checked);
											setChecked(event, "activeCustomer");
										}}
										inputProps={{ "aria-label": "controlled" }}
										sx={{ mt: 0.3 }}
									/>
								}
							/>
							<Typography sx={{ mt: 1.5, ml: -2, }}>
								Active Customers Only
							</Typography>
						</Box>
					</Grid>
					<Grid item  sm={2} md={1.5}  >
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
							}}
						>
							<FormControlLabel
								control={
									<Checkbox
										checked={newCustomer}
										onChange={(event) =>
											setChecked(event, "newCustomer")
										}
										inputProps={{ "aria-label": "controlled" }}
										sx={{ mt: 0.3 }}
									/>
								}
							/>
							<Typography sx={{ mt: 1.5, ml: -2, }}>
								New Customers Only
							</Typography>
						</Box>
					</Grid>
					<Grid item sm={.72} mb={2} sx={{
								ml:"calc(100% - 140px)",
								mt: -8,
							}}>
						<Button
							startIcon={<SearchIcon />}
							sx={{
								bgcolor: colors.blue,
								color: colors.white,
								textTransform: "none",
								"&:hover": {
									bgcolor: colors.lightBlue,
								},
								
							}}
							onClick={searchCustomer}
						>
							Search
						</Button>
					</Grid>
				</Grid>
			</Box>
         
			<TransferList
				leftList={customers}
				rightList={selCustomers}
				leftState={"customers"}
				rightState={"selCustomers"}
			/>

			<BasicModal />
		</Box>
		</CollapseSection>
		</Box>
	);
}
